<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 200 160"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		:class="className"
	>
		<g>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M37.5002 61.8869C37.5002 76.2985 57.955 73.942 57.955 100.565C57.955 126.99 19.3766 123.074 48.0077 151.128C73.9586 176.555 68.7165 139.245 102.273 139.245C117.493 139.245 124.728 157.14 134.759 159.663C143.777 161.932 162.5 142.905 162.5 135.929C162.5 121.944 142.045 123.276 142.045 95.0403C142.045 71.2026 179.422 73.2087 153.128 47.794C138.76 33.9057 136.627 34.5686 121.902 46.7182C118.316 49.6771 112.5 56.9894 112.5 61.8869C112.5 72.2807 134.09 81.2845 134.09 98.3557C134.09 110.325 125.818 118.094 119.062 123.526C92.2819 145.052 65.9081 116.276 65.9081 97.2503C65.9081 82.3481 82.075 76.1913 86.343 65.0766C90.6149 53.9517 67.4989 37.5737 62.499 37.5737C55.8717 37.5737 51.1446 43.6432 47.443 47.2442C43.7414 50.844 37.5002 55.4412 37.5002 61.8869Z"
				:fill="color"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M76.1354 23.2077C76.1354 36.2085 115.61 54.3137 88.3612 80.4074C71.2716 96.774 73.5012 99.6611 86.0782 111.894C100.846 126.255 103.992 123.759 116.193 111.893C121.004 107.215 126.136 104.643 126.136 97.2503C126.136 86.3511 104.815 77.8137 104.816 60.7814C104.818 41.5103 126.136 36.9038 126.136 23.2077C126.136 17.7944 109.643 0 101.136 0C92.9117 0 76.1354 18.2321 76.1354 23.2077Z"
				:fill="color"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M9.15527e-05 96.1465C9.15527e-05 104.976 4.24765 106.356 10.5102 112.447C24.6396 126.187 25.0073 126.533 38.92 112.999C48.8779 103.312 49.9999 105.407 49.9999 96.1465C49.9999 93.3347 30.4753 73.4441 25.1682 73.522C19.1027 73.6111 15.0714 79.8304 11.6472 83.16C9.05836 85.6792 9.15527e-05 92.7317 9.15527e-05 96.1465Z"
				:fill="color"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M150 96.1466C150 104.976 154.248 106.356 160.511 112.447C174.912 126.451 175.088 126.451 189.488 112.447C195.636 106.468 199.055 102.903 200 99.8497V96.4271C198.989 93.2457 195.191 89.8117 188.921 83.7136C185.416 80.3044 180.983 73.6132 174.83 73.522C168.984 73.4336 150 93.879 150 96.1466Z"
				:fill="color"
			/>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'WalterIAIcon',
	props: {
		size: {
			type: Number,
			default: 24,
		},
		color: {
			type: String,
			default: '#C0F01A',
		},
		className: {
			type: String,
			default: '',
		},
	},
}
</script>

<style scoped>
svg {
	transition: transform 0.2s ease;
}
svg:hover {
	transform: scale(1.05);
}
</style>
